/**
 * Created by hoangnk on 2017/07/19.
 */

let LOCAL_HOST = 'http://localhost:8000/'
let TEST_HOST = 'https://test.timesheet-api.vtijapan.co.jp/'
let PRODUCTION_HOST = 'https://timesheet-api.vtijapan.co.jp/'
let UAT_HOST = 'http://uat-api.ts.vti.com.vn/'

var host = LOCAL_HOST

if (process.env.NODE_ENV === 'testing') {
  host = TEST_HOST
} else if (process.env.NODE_ENV === 'production') {
  host = PRODUCTION_HOST
} else if (process.env.NODE_ENV === 'uat') {
  host = UAT_HOST
}
console.log(process.env.NODE_ENV)

var ROLE = {
  ADMIN: 1,
  TEAMLEAD: 2,
  MEMBER: 3,
  GROUPMANAGER: 4,
  ACCOUNTANT: 5,
  IINCHO: 6
}

module.exports = {
  LUNCH_TIME: '01:00', // default break time
  START_WORKING: '09:00', // default start time
  END_WORKING: '18:00', // default end time
  NORMAL_WORKING_TIME: 8.5, // calculate OT after 9.5h
  TOKEN_KEY: 'access_token', // key of data save in local storage
  EXPIRED_DATE: 'expired_date', // key of data save in local storage
  USER_PROFILE: 'user_profile', // key of data save in local storage
  SYSTEM_ERROR_MESSAGE: 'Sorry!!! System has error... Please contact to admin.', // message show when system has any error
  HOST: host,
  // role for user
  ROLE: ROLE,
  ALL_ROLE: [ROLE.ADMIN, ROLE.TEAMLEAD, ROLE.MEMBER, ROLE.GROUPMANAGER, ROLE.ACCOUNTANT, ROLE.IINCHO],
  // type off day off, same as DB and server
  DAY_OFF_TYPE: {
    ALLOWED: 1,
    LAST_YEAR: 2,
    SUMMER: 3,
    WEDDING: 5, // nghi cuoi
    FAMILY: 7, // viec hieu hi ruot thit
    RELATION: 8, // viec hieu, hy anh em ho hang
    WORKING: 9, // ngay lam viec
    HALF_DAY: 10, // nghi nua ngay
    JAPAN_HOLIDAY: 11, // nghi nua ngay
    WEEKEND: 12, // nghi nua ngay
    NOT_ALLOWED: 13, // nghi nua ngay
    SUBSTITUTE: 14 // nghi bu
  },
  DAY_OFF_NEED_ADMIN: 5, // if day off amount > this value admin will be required for approved
  DAY_OFF_TIME: {
    ALL_DAY: { 'id': 1, 'name': '全日' },
    MORNING: { 'id': 2, 'name': '午前' },
    AFTERNOON: { 'id': 3, 'name': '午後' }
  },
  // validation config for vee-validation
  VALIDATE_CONFIG: {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'field',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    classes: false,
    classNames: {
      touched: 'touched', // the control has been blurred
      untouched: 'untouched', // the control hasn't been blurred
      valid: 'valid', // model is valid
      invalid: 'invalid', // model is invalid
      pristine: 'pristine', // control has not been interacted with
      dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true,
    validity: true,
    aria: true
  },

  OT_TYPE_WEEKEND: {
    SUBTITUDE_DAY_OFF: { 'id': 1, 'name': '代休' },
    OVERTIME: { 'id': 0, 'name': '残業' }
  },

//   COMPANY_HOLIDAY: [
//     {
//       'date': {
//         'day': 30,
//         'month': 12,
//         'year': 2019,
//         'dayOfWeek': 1
//       },
//       'localName': '年末休暇 Nenmatsunenshi',
//       'englishName': `New Year's Eve`
//     },
//     {
//       'date': {
//         'day': 31,
//         'month': 12,
//         'year': 2019,
//         'dayOfWeek': 2
//       },
//       'localName': '年末休暇 Nenmatsunenshi',
//       'englishName': `New Year's Eve`
//     },
//     {
//       'date': {
//         'day': 2,
//         'month': 1,
//         'year': 2020,
//         'dayOfWeek': 4
//       },
//       'localName': '年始休暇 Nenmatsunenshi',
//       'englishName': `New Year's Day`
//     },
//     {
//       'date': {
//         'day': 3,
//         'month': 1,
//         'year': 2020,
//         'dayOfWeek': 5
//       },
//       'localName': '年始休暇 Nenmatsunenshi',
//       'englishName': `New Year's Day`
//     },
//     {
//       'date': {
//         'day': 30,
//         'month': 4,
//         'year': 2019,
//         'dayOfWeek': 2
//       },
//       'localName': '国民の休日 Kokuminnokyujitsu',
//       'englishName': 'National Holiday'
//     },
//     {
//       'date': {
//         'day': 1,
//         'month': 5,
//         'year': 2019,
//         'dayOfWeek': 3
//       },
//       'localName': '即位の日 Sokuinohi',
//       'englishName': 'Day of Throne'
//     },
//     {
//       'date': {
//         'day': 2,
//         'month': 5,
//         'year': 2019,
//         'dayOfWeek': 4
//       },
//       'localName': '国民の休日 Kokuminnokyujitsu',
//       'englishName': 'National Holiday'
//     },
//     {
//       'date': {
//         'day': 22,
//         'month': 10,
//         'year': 2019,
//         'dayOfWeek': 2
//       },
//       'localName': '即位礼正殿の儀',
//       'englishName': ''
//     }
//   ],

COMPANY_HOLIDAY: [
  {
    'summary': '年末休暇',
    'start': {
      'date': '2023-12-29'
    }
  },
  {
    'summary': '年始休暇',
    'start': {
      'date': '2024-01-02'
    }
  },
  {
    'summary': '年始休暇',
    'start': {
      'date': '2024-01-03'
    }
  },
  {
    'summary': '振替休日',
    'start': {
      'date': '2024-05-06'
    }
  },
  {
    'summary': '年末休暇',
    'start': {
      'date': '2024-12-30'
    }
  }
],

  EXCLUSION_HOLIDAY: [
    {
      date: "2024-11-15",
    },
    {
      date: "2025-03-03",
    },
  ],

  BUDGET_TYPE: {
    'CERTIFICATE': 1,
    'SEMINAR': 2,
    'BOOK': 3,
    'OTHER': 4
  },

  STATUS: {
    'PENDING': 0,
    'APPROVED': 1,
    'REJECTED': 2,
    'CANCELED': 3
  },

  GOOGLE_CLIENT_ID: '75443299773-pc300f6hal6j57qq6bp2siadi78sj3u5.apps.googleusercontent.com',
  GOOGLE_CALENDAR_API_KEY: 'AIzaSyDzJP-WCAhbQBNl4QbRZQKyL2B0LCQcjlE'
}



// WEBPACK FOOTER //
// ./client/services/globalservice.js